module.exports = __webpack_public_path__ + "static/media/fb.3f7e78b5.svg";